import { Row, Col, Container, Card } from 'react-bootstrap'; 
import TypeAnimation from 'react-type-animation';
import Highlighter from "react-highlight-words";

export default function About() {
    return (
      <Container id="about" className="text-center mt-5">
      <TypeAnimation
        cursor={false}
        sequence={[ 
           'About Me', 1000, 
           'Get to know me', 1000, 
           'Tungkol sakin', 1000, 
           'om mig', 1000, 
           'sobre mi', 1000, 
           'de me', 3000,
           'About Me', 1000]}
        wrapper="p"
        className="about-me-label mt-1"
        />
        <Row>
           <Col lg={6} xs={12} md={6}>
                <Card className="about-text-1">
                  <Card.Body>
                    <Card.Text className="p-4">
                      <Highlighter
                         highlightClassName="YourHighlightClass-1"
                         searchWords={["Martin Miguel", 'Superloop', "VostroNet Australia Pty Ltd", "UI/UX","Backend", "Fullstack web developer", "zuitt coding bootcamp"]}
                         autoEscape={true}
                         textToHighlight="Currently working as a fullstack web developer-Broadband Networks and Smart Communities for Superloop formerly known as VostroNet Australia Pty Ltd at EMAPTA Philippines with previous work experience as a developer and IT instructor for a Fullstack web development course at Zuitt Coding Bootcamp. I enjoy reading manuals, watching youtube tutorials, and reposting reddit threads. im currently learning how to read, write, and speak deutsch."
                       />

                       <TypeAnimation
                         cursor={false}
                         sequence={[ 
                            'Creative', 1000, 
                            'Resourceful', 1000, 
                            'Good taste in color palette', 1000, 
                            'Determined', 1000, 
                            'can work with minimal supervision', 1000, 
                            'promotes positive atmosphere in the workplace', 3000,
                            'good penmanship', 1000]}
                         wrapper="p"
                         repeat={Infinity}
                         className="footprints-me mt-1"
                       />

                       <Highlighter
                          highlightClassName="YourHighlightClass-1"
                          searchWords={["Martin Miguel", "UI/UX", " web development instructor", "Backend", "Full stack", "zuitt coding bootcamp"]}
                          autoEscape={true}
                          textToHighlight="im willing to learn and unlearn so that i will be able to adapt properly to standards and practices for the project."
                          className="last-words"
                        />


                    </Card.Text>
                  </Card.Body>
                </Card>
            </Col>
            <Col lg={6} xs={12} md={6}>
                <Card className="about-text">
                  <Card.Body>
                     <Card.Title>
                       <TypeAnimation
                         cursor={false}
                         sequence={[ 
                            'Hello', 1000, 
                            'Greetings', 1000, 
                            'Hallo', 1000, 
                            'salutations', 1000, 
                            'DM me', 1000, 
                            'Call me', 1000]}
                         wrapper="p"
                         className="about-me mt-2"
                         />
                    </Card.Title>
                    <Card.Text className="p-4">
                      <Highlighter
                         highlightClassName="YourHighlightClass"
                         searchWords={["Martin Miguel", "UI/UX", " web development", "Backend", "Full stack"]}
                         autoEscape={true}
                         textToHighlight=" My Name is Martin Miguel, Here to serve your web development needs in UI/UX, Backend & Full stack at the best possible price, let's collaborate."
                       />
                    </Card.Text>
                  </Card.Body>
                </Card>
             </Col>
         </Row>
      </Container>
    );
  }
  

  